export function getCurrentUrl(pathname: string) {
	return pathname.split(/[?#]/)[0];
}

export function checkIsActive(pathname: string, url: string) {
	const current = getCurrentUrl(pathname);
	if (!current || !url) {
		return false;
	}

	if (current === url) {
		return true;
	}

	// Match only if url is a parent path (not substring matching)
	// This prevents '/player' from matching '/client/account/manage-operator/true'
	if (current.startsWith(url + '/')) {
		return true;
	}

	return false;
}

export function getSidebarRouteConfig() {
	let allSidebar = [
		{ _name: "home", lebel: "Dashboard", link: "/home", icon: "bi bi-bar-chart-line", fi: "bi-app-indicator", bullet: false },
		{ _name: "user_role_management", lebel: "BO User/Role Settings", link: "/user-role-management", icon: "bi bi-shield-lock", fi: "bi-layers", bullet: false },
		{ _name: "role_management", lebel: "Role Management", link: "/user-role-management/role-management", icon: "address-book", fi: "bi-app-indicator", bullet: false },
		// { _name: "user_management", sub: null, lebel: "User Management", link: "/user-role-management/user-management", icon: "address-book", fi: "bi-app-indicator", bullet: false },

		{ _name: "wallet", lebel: "Wallet", link: "/home/Wallet", icon: "bi bi-bank", fi: "bi bi-bank", bullet: false },
		{ _name: "wallet_view_details", lebel: "View Details", link: "/wallet/transaction-history", icon: null, fi: null, bullet: true },
		{ _name: "wallet_update_balance", lebel: "Update Balance", link: "/wallet/update-balance", icon: null, fi: null, bullet: true },

		{ _name: "client_management", lebel: "Client Management", link: "/clients", icon: "bi bi-people", fi: "bi-layers", bullet: false },
		{ _name: "client_management_all_client_list", lebel: "Client List", link: "/clients/all", icon: null, fi: null, bullet: true },
		{
			_name: "provider_management",
			lebel: "Provider",
			link: "/provider/all-provider-list",
			icon: "bi bi-buildings",
			fi: "bi-app-indicator",
			bullet: false,
		},
		//{ _name: "provider_management_provider_list", lebel: "Provider List", link: "/provider-management/provider-list", icon: null, fi: null, bullet: true },

		//
		{ _name: "report_management", lebel: "Report", link: "/reports", icon: "bi bi-clipboard-data", fi: "bi-app-indicator", bullet: false },
		{ _name: "report_management_reports_games", lebel: "Game Wise", link: "/reports/game-wise-report", icon: null, fi: null, bullet: true },
		{ _name: "report_management_reports_providers", lebel: "Provider Wise", link: "/reports/provider-wise-report", icon: null, fi: null, bullet: true },
		{ _name: "report_management_reports_categories", lebel: "Category Wise", link: "/reports/category-wise-report", icon: null, fi: null, bullet: true },
		{ _name: "report_management_reports_revenue", lebel: "Revenue", link: "/reports/revenue-report", icon: null, fi: null, bullet: true },
		{ _name: "report_management_reports_transaction", lebel: "Wallet Transaction", link: "/reports/wallet-transactions-report", icon: null, fi: null, bullet: true },
		{ _name: "report_management_reports_provider_transaction", lebel: "Provider Transaction", link: "/reports/provider-transaction-report", icon: null, fi: null, bullet: true },

		//
		{ _name: "player_management", lebel: "User Management", link: "/player", icon: "bi bi-people", fi: "people", bullet: false },
		{ _name: "player_management_player_list", lebel: "Player List", link: "/player/all-player-list", icon: null, fi: null, bullet: true },
		{ _name: "player_management_suspicious_activity_list", lebel: "Security Incident Logs", link: "/player/suspicious-activity-list", icon: null, fi: null, bullet: true },
		//
		{ _name: "game_management", lebel: "Game", link: "/game", icon: "bi bi-controller", fi: "bi-layers", bullet: false },
		{ _name: "game_management_all_game_list", lebel: "Game List", link: "/game/all-game-list", icon: null, fi: null, bullet: true },
		{ _name: "game_management_top_games", lebel: "Top Games", link: "/game/select-top-ranking", icon: null, fi: null, bullet: true },
		{ _name: "game_management_upload_games", lebel: "Upload New Games", link: "/game/upload-new-games", icon: null, fi: null, bullet: true },
		{ _name: "category", lebel: "Category", link: "/categories", icon: "bi bi-controller", fi: "bi-layers", bullet: false },
		//
		{
			_name: "assign_inactive_providers",
			lebel: "Assign Provider",
			link: "/assign-providers",
			icon: "bi bi-x-circle-fill",
			fi: "bi-app-search",
			bullet: false,
		},

		{ _name: "assign_inactive_games", lebel: "Assign Game", link: "/assign-games", icon: "bi bi-bullseye", fi: "bi-app-search", bullet: false },

		{ _name: "assign_game_by_provider", lebel: "Assign Game by Provider", link: "/assign-games-by-provider", icon: "bi bi-bullseye", fi: "bi-app-search", bullet: false },

		{ _name: "all_provider_game_assign", lebel: "Assign All Provider Games", link: "/assign-all-provider-games", icon: "bi bi-bullseye", fi: "bi-app-search", bullet: false },

		{ _name: "search_user", lebel: "Search Client / User", link: "/search-client-user", icon: "bi bi-search", fi: "bi-app-search", bullet: false },

		{ _name: "evo_skins", lebel: "Evo Skins", link: "evo-skins", icon: "gear", fi: "bi-app-search", bullet: false },

		{ _name: "settings", lebel: "Settings", link: "/settings", icon: "gear", fi: "bi-app-search", bullet: false },
		{ _name: "currency", lebel: "Currency", link: "/settings/currency", icon: "null", fi: "null", bullet: true },
		{ _name: "bet_range", lebel: "Bet Range", link: "/settings/bet-range", icon: "null", fi: "null", bullet: true },
		{ _name: "global_maintenance", lebel: "Global Maintenance Mode", link: "/settings/global-maintenance", icon: "null", fi: "null", bullet: true },
		{ _name: "launch_game", lebel: "Player Game Launch", link: "/settings/launch-game", icon: "null", fi: "null", bullet: true },

		{ _name: "developers", lebel: "Developers", link: "/developers", icon: "bi bi-code-slash", fi: "bi-layers", bullet: false },
		{ _name: "developers_all_client_api_list", lebel: "Client Api List", link: "/developers/client-api-listing", icon: null, fi: null, bullet: true },
		{ _name: "developers_all_test_case_list", lebel: "Test Case List", link: "/developers/test-case-listing", icon: null, fi: null, bullet: true },
		// { _name: "developers_all_test_case_report", lebel: "Test Case Report", link: "/developers/test-case-report", icon: null, fi: null, bullet: true },

		{ _name: "logs", lebel: "Logs", link: "/logs", icon: "gear", fi: "bi-app-search", bullet: false },
		{ _name: "provider_logs", lebel: "Provider Logs", link: "/logs/provider-logs", icon: "null", fi: "null", bullet: true },
		{ _name: "response_graph", lebel: "Response Graph", link: "/logs/response-graph", icon: "null", fi: "null", bullet: true },
		{ _name: "client_logs", lebel: "Client Logs", link: "/logs/client-logs", icon: "null", fi: "null", bullet: true },

		{ _name: "assign_free_spins", lebel: "Assign Free Spins", link: "/assign-free-spins", icon: "bi bi-bullseye", fi: "bi-app-search", bullet: false },
	];
	return allSidebar;
}

export const SIDEBAR = [
	{ _name: "home", sub: null },
	{
		_name: "user_role_management",
		sub: [
			{ _name: "role_management", sub: null },
			// { _name: "user_management", sub: null, }
		]
	},
	{
		_name: "wallet",
		sub: [
			{ _name: "wallet_view_details", sub: null },
			{ _name: "wallet_update_balance", sub: null },
		],
	},
	{
		_name: "client_management",
		sub: [{ _name: "client_management_all_client_list", sub: null }],
	},
	{
		_name: "search_user",
		sub: null,
	},
	{
		_name: "player_management",
		sub: [
			{ _name: "player_management_player_list", sub: null },
			{ _name: "player_management_suspicious_activity_list", sub: null },
		],
	},
	{
		_name: "report_management",
		sub: [
			{ _name: "report_management_reports_games", sub: null },
			{ _name: "report_management_reports_providers", sub: null },
			{ _name: "report_management_reports_categories", sub: null },
			{ _name: "report_management_reports_revenue", sub: null },
			{ _name: "report_management_reports_transaction", sub: null },
			{ _name: "report_management_reports_provider_transaction", sub: null },
		],
	},
	{
		_name: "game_management",
		sub: [
			{ _name: "game_management_all_game_list", sub: null },
			{ _name: "game_management_top_games", sub: null },
			{ _name: "game_management_upload_games", sub: null },
			{
				_name: "game_management_game_category",
				sub: null,
			},
		],
	},
	{
		_name: "category",
		sub: null
	},
	{
		_name: "provider_management",
		sub: null,
	},
	{
		_name: "assign_inactive_providers",
		sub: null,
	},
	{
		_name: "assign_inactive_games",
		sub: null,
	},
	{
		_name: "assign_game_by_provider",
		sub: null,
	},
	{
		_name: "all_provider_game_assign",
		sub: null,
	},
	{
		_name: "assign_free_spins",
		sub: null,
	},

	// {
	// 	_name: "home_setting",
	// 	sub: null,
	// },
	{
		_name: "settings",
		sub: [
			{ _name: "global_maintenance", sub: null },
			{ _name: "currency", sub: null },
			{ _name: "bet_range", sub: null },
			{ _name: "launch_game", sub: null },
		],
	},
	{
		_name: "developers",
		sub: [
			{ _name: "developers_all_client_api_list", sub: null },
			{ _name: "developers_all_test_case_list", sub: null },
			// { _name: "developers_all_test_case_report", sub : null }
		],
	},
	{
		_name: "logs",
		sub: [
			{ _name: "provider_logs", sub: null },
			{ _name: "response_graph", sub: null },
			{ _name: "client_logs", sub: null }
		],
	},
	{
		_name: "evo_skins",
		sub: null,
	},

];
